import { SonoraNetworkCallStatus } from 'owa-editor-sonora-types';
import { Spinner } from '@fluentui/react/lib/Spinner';
import loc from 'owa-localize';
import React from 'react';
import {
    SonoraSearchingText,
    SonoraNoResultsFoundText,
    SonoraNoResultsFoundForEmptyQueryText,
    SonoraResultsTimeoutLabel,
} from './SonoraResultsStatusBar.locstring.json';

import sonoraCommonStyles from './SonoraCommonStyles.scss';
import classnamesBind from 'classnames/bind';
let classNames = classnamesBind.bind(sonoraCommonStyles);

export interface SonoraResultsStatusBarProps {
    status: SonoraNetworkCallStatus;
    queryString: string;
    numberOfResults: number;
    onTimeout: () => void;
}

const SonoraResultsStatusBar = (props: SonoraResultsStatusBarProps): JSX.Element => {
    switch (props.status) {
        case SonoraNetworkCallStatus.Pending:
            return (
                <div className={sonoraCommonStyles.statusBarContainer}>
                    <div className={sonoraCommonStyles.spinnerContainer}>
                        <Spinner />
                    </div>
                    <div className={sonoraCommonStyles.statusText}>
                        {loc(SonoraSearchingText, props.queryString)}
                    </div>
                </div>
            );
        case SonoraNetworkCallStatus.OWSTimeout:
            return (
                <div className={classNames(sonoraCommonStyles.hoverable)} onClick={props.onTimeout}>
                    <div className={sonoraCommonStyles.statusBarContainer}>
                        <div
                            className={classNames(
                                sonoraCommonStyles.statusText,
                                sonoraCommonStyles.centered,
                                sonoraCommonStyles.suggestionButtonContainer
                            )}>
                            {loc(SonoraResultsTimeoutLabel)}
                        </div>
                    </div>
                </div>
            );
        default:
            return props.numberOfResults ? (
                <></>
            ) : (
                <div className={sonoraCommonStyles.statusBarContainer}>
                    <div
                        className={classNames(
                            sonoraCommonStyles.statusText,
                            sonoraCommonStyles.centered
                        )}>
                        {props.queryString === ''
                            ? loc(SonoraNoResultsFoundForEmptyQueryText)
                            : loc(SonoraNoResultsFoundText)}
                    </div>
                </div>
            );
    }
};

export default SonoraResultsStatusBar;
